const Lists = {
	Init() {
		Lists.Plans();
	},
	Plans() {
		$('.list-plans').on('click', '.item-link', e => {
			e.preventDefault();
		});

		$('.list-plans')
			.on('click mouseover', '.list-item', function over(e) {
				$('.list-plans .list-item').removeClass('active');
				$(this).addClass('active');
			})
			.on('mouseout', '.list-item', function out(e) {
				$(this).removeClass('active');
			});
	}
};

export default Lists;
